import React from "react";
import styled from "styled-components";
import axisDefault from "../../images/axis/axis.svg";
import {CircularProgressBar} from "../progress-bar/CircularProgressBar";
import {getImage} from "../../utils/utils";

const AxisCard = ({axis}) => {
    return (
            <Card>
                <div className="axis-card-container">
                    <img className="axis-card-img" src={getImage(axis.image, axisDefault)} alt=""/>
                    <CircularPB>
                        {CircularProgressBar(Math.round(axis.stakeAdvancementAVG))}
                    </CircularPB>
                </div>
                <h2>{axis.name}</h2>
            </Card>
    );
}
const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  padding: 0.8rem;
  border-radius: 15px;
  box-shadow: 1px 1px 5px rgb(0 0 0 / 10%);
  
  @media print{
    padding: 0.5rem;
  }
  
  img{
    max-width: 50px;
    object-fit: contain;
  }
  h2{
    font-size: 15px;
    text-align: center;
    @media print{
      font-size: 11px;
    }
  }
  

  .axis-card-container{
    
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    padding: 0.5rem;
    gap: 0.5rem;
    @media print{
      padding: 0;
      display: grid;
      grid-template-columns: 40% 60%;
    }
    
  }
`

const CircularPB = styled.div`
  width: 100px;
  #circular-progress-bar div svg  {
    max-width: 50%;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
  .rc-progress-circle {
    width: 40px;
  }
  #circular-progress-bar div h4{
    bottom: 2.05rem;
    font-size: 0.8rem;
  }
  @media print{
    max-width: 60px;
  }
`
export default AxisCard;
